import { extractType } from '../primitives';
import { extractUrlFromIconJsonLd } from '../url';
export var extractContext = function extractContext(jsonLd) {
  var context = jsonLd.context;
  if (context) {
    if (typeof context === 'string') {
      return {
        name: context
      };
    } else if (context['@type'] === 'Link') {
      if (context.name) {
        return {
          name: context.name
        };
      }
    } else {
      if (context.name) {
        return {
          name: context.name,
          icon: context.icon && extractUrlFromIconJsonLd(context.icon),
          type: extractType(context)
        };
      }
    }
  }
};